let bindingsReady = false;

function dispatchCmpthFormEvent(name, target, detail = {}) {
  if (!(target instanceof Element) && target !== document) {
    return;
  }

  target.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      detail,
    })
  );
}

function removeMessage(event) {
  const target = event?.target;

  if (!(target instanceof Element)) {
    return;
  }

  gsap.to(target, {
    autoAlpha: 0,
    duration: 0.4,
    ease: 'Power3.easeInOut',
    onComplete: function () {
      target.remove();
    },
  });
}

function removeElement(element) {
  if (!(element instanceof Element)) {
    return;
  }

  gsap.to(element, {
    autoAlpha: 0,
    duration: 0.4,
    ease: 'Power3.easeInOut',
    onComplete: function () {
      element.remove();
    },
  });
}

function getValidationMessages(root = document) {
  if (!(root instanceof Element) && root !== document) {
    return [];
  }

  return Array.from(
    root.querySelectorAll([
      '.wpcf7-not-valid-tip',
      '.gfield_validation_message',
      '.gform_validation_errors',
      '.gform_submission_error',
      '.validation_message',
    ].join(', '))
  );
}

function bindDismissibleValidationMessages(root = document) {
  getValidationMessages(root).forEach(element => {
    if (element.dataset.cmpthDismissibleBound === 'true') {
      return;
    }

    element.dataset.cmpthDismissibleBound = 'true';
    element.addEventListener('click', removeMessage, false);
  });
}

function maybeOpenDownload(target) {
  if (!(target instanceof Element)) {
    return;
  }

  const download = target.querySelector('[data-download]');

  if (!download?.dataset?.download) {
    return;
  }

  window.open(download.dataset.download, '_blank');
}

function findGravityForm(formId) {
  if (!formId) {
    return null;
  }

  return document.querySelector(`#gform_${formId}`)
    || document.querySelector(`#gform_wrapper_${formId} form`);
}

function handleGravityFormRender(formId) {
  const form = findGravityForm(formId);
  const scope = form || document.querySelector(`#gform_wrapper_${formId}`) || document;

  bindDismissibleValidationMessages(scope);

  if (!scope.querySelector('.gfield_error, .gfield_validation_message, .gform_validation_errors, .gform_submission_error, .validation_message')) {
    return;
  }

  dispatchCmpthFormEvent('cmpth:form-invalid', form || scope, {
    provider: 'gravityforms',
    formId,
  });
}

function bindCf7Events() {
  document.addEventListener(
    'wpcf7submit',
    function (event) {
      const form = event?.target;

      dispatchCmpthFormEvent('cmpth:form-submit', form || document, {
        provider: 'cf7',
        originalEvent: event,
      });

      window.setTimeout(function () {
        bindDismissibleValidationMessages(document);
      }, 1000);
    },
    false
  );

  document.addEventListener(
    'wpcf7invalid',
    function (event) {
      const form = event?.target;

      dispatchCmpthFormEvent('cmpth:form-invalid', form || document, {
        provider: 'cf7',
        originalEvent: event,
      });

      window.setTimeout(function () {
        bindDismissibleValidationMessages(document);
      }, 1000);
    },
    false
  );

  document.addEventListener(
    'wpcf7mailsent',
    function (event) {
      const form = event?.target;

      maybeOpenDownload(form);

      dispatchCmpthFormEvent('cmpth:form-success', form || document, {
        provider: 'cf7',
        originalEvent: event,
      });
    },
    false
  );
}

function bindGravityFormsEvents() {
  document.addEventListener('submit', function (event) {
    const form = event?.target;

    if (!(form instanceof HTMLFormElement) || !/^gform_/.test(form.id || '')) {
      return;
    }

    dispatchCmpthFormEvent('cmpth:form-submit', form, {
      provider: 'gravityforms',
      formId: form.id.replace('gform_', ''),
      originalEvent: event,
    });
  });

  document.addEventListener('gform/post_render', function (event) {
    handleGravityFormRender(event?.detail?.formId);
  });

  if (!window.jQuery) {
    return;
  }

  window.jQuery(document).on('gform_post_render.cmpthForms', function (_event, formId) {
    handleGravityFormRender(formId);
  });

  window.jQuery(document).on('gform_confirmation_loaded.cmpthForms', function (event, formId) {
    const scope = document.querySelector(`#gform_wrapper_${formId}`) || findGravityForm(formId) || document;

    maybeOpenDownload(scope);

    dispatchCmpthFormEvent('cmpth:form-success', scope, {
      provider: 'gravityforms',
      formId,
      originalEvent: event,
    });
  });
}

export function initFormMessages() {
  bindDismissibleValidationMessages(document);

  if (bindingsReady) {
    return;
  }

  bindingsReady = true;
  bindCf7Events();
  bindGravityFormsEvents();
}

export function initNewsLetterForm() {
  document.querySelectorAll('.suscribe-form').forEach(scope => {
    if (!(scope instanceof Element) || scope.dataset.cmpthNewsletterBound === 'true') {
      return;
    }

    const mailInput = scope.querySelector('input[type="email"]');
    const submitBtn = scope.querySelector('[type="submit"]');

    if (!(mailInput instanceof HTMLInputElement) || !(submitBtn instanceof HTMLButtonElement || submitBtn instanceof HTMLInputElement)) {
      return;
    }

    scope.dataset.cmpthNewsletterBound = 'true';
    submitBtn.disabled = true;

    const isStrictValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    mailInput.addEventListener('input', function () {
      const email = mailInput.value.trim();
      submitBtn.disabled = !isStrictValidEmail(email);
    });
  });
}
